import React from 'react';
import CssBaseline from '@material-ui/core/CssBaseline';
import Grid from '@material-ui/core/Grid';
import { Typography, withStyles } from '@material-ui/core';
// import { Storage } from 'aws-amplify';
// import Preparing from '../components/Preparing';
import Topbar from '../components/Topbar';
import Footer from '../components/Footer';
import Container from '../components/Div/Container';
import MainTitle from '../components/Text/MainTitle';
import SubTitle from '../components/Text/SubTitle';
import ConfirmButton from '../components/Button/ConfirmButton';
import { EVENT_IMG } from '../constatns';

const styles = (theme) => ({
  importantDateDiv: {
    backgroundColor: 'rgba(15, 79, 141, 0.05)',
    borderRadius: '20px',
    padding: theme.spacing(5, 0),
    textAlign: 'center',
  },
  title: {
    color: theme.palette.primary.main,
    fontWeight: 'bold',
    fontSize: '1.6em',
    lineHeight: 2,
    paddingTop: 10,
  },
  subtitle: {
    color: '#555',
    fontWeight: 500,
    fontSize: '1.2em',
    '& span': {
      fontWeight: 'bold',
      color: theme.palette.primary.main,
    },
  },
  orderedList: {
    '& li': { marginBottom: '.5rem', fontWeight: 500, fontSize: '1.2em' },
    '& span': { color: theme.palette.secondary.main, fontWeight: 'bold' },
  },
});

class SpeakerGuide extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      matches: window.matchMedia('(max-width:600px)').matches,
    };
  }

  componentDidMount() {}

  render() {
    const { classes } = this.props;

    const spaceDiv = () => {
      return (
        <Grid item xs={8}>
          <div style={{ height: '30px' }} />
        </Grid>
      );
    };

    return (
      <div>
        <CssBaseline />
        <Topbar MIdx={4} SIdx={0} />
        <Container>
          <Grid container justifyContent={'center'}>
            <Grid item xs={8}>
              <MainTitle>Guidelines</MainTitle>
            </Grid>
            <Grid item xs={8}>
              <div className={classes.importantDateDiv}>
                <img src={`${EVENT_IMG}/ic/ic_calendar.png`} alt="" style={{ width: '100px', height: '100px' }} />
                <Typography className={classes.title}>Important Dates</Typography>
                <Typography className={classes.subtitle}>
                  Deadline for Speaker Abstracts Submission & Modification : <span>October 17(Mon), 2022</span>
                </Typography>
              </div>
            </Grid>
            {spaceDiv()}
            <Grid item xs={8}>
              <SubTitle>Important Dates</SubTitle>
              <div style={{ color: '#777' }}>
                <ol className={classes.orderedList}>
                  <li>
                    All materials must be submitted online via <a href="https://www.prskorea.org/">https://www.prskorea.org/</a> no later
                    than <span style={{ color: '#237a9d' }}>October 21(Fri), 2022.</span>
                  </li>
                  <li> Submitted abstracts can be revised on the website during the abstract submission period.</li>
                  <li> This is an international academic conference. The abstracts should be written in English.</li>
                  <li> The abstract should not exceed 350 words.</li>
                  <li>
                    Please click <span style={{ color: '#237a9d' }}>“CV Form Download”</span> box below and fill out your information into
                    download file.
                  </li>
                  <li> Please submit your abstract with your CV form as an attached file on the website.</li>
                </ol>
              </div>
            </Grid>
            {spaceDiv()}
            <Grid item xs={8}>
              <div style={{ display: 'flex', justifyContent: 'center' }}>
                <ConfirmButton
                  color="secondary"
                  onClick={() => {
                    window.open('https://innon.s3.ap-northeast-2.amazonaws.com/PRS2022/Curriculum+Vitae_PRS+KOREA+2022.docx');
                  }}
                  style={{ textTransform: 'none', color: '#fff' }}
                >
                  CV Form Download
                </ConfirmButton>
                <div style={{ width: '20px' }} />
                <ConfirmButton
                  color="primary"
                  onClick={() => this.props.history.push('/speaker/submission')}
                  style={{ textTransform: 'none' }}
                >
                  Speaker Abstract Submission
                </ConfirmButton>
              </div>
            </Grid>
            {spaceDiv()}
          </Grid>
        </Container>
        <Footer />
      </div>
    );
  }
}

export default withStyles(styles, { withTheme: true })(SpeakerGuide);
